import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import { formatterMonth } from '../../utils/formatters';
import {
  loadWalletInfoCompletion,
  loadWalletFlowListCompletion,
  loadMoneyExportInfoCompletion,
  exportMoneyCompletion,
} from '../../actions';

export function* watchLoadWalletInfo() {
  yield takeEvery('LOAD_WALLET_INFO', function*() {
    const options = {
      url: '/api/b/wallet/info',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadWalletInfoCompletion(result.data, result.error));
  });
}

export function* watchLoadWalletFlowList() {
  yield takeEvery('LOAD_WALLET_FLOW_LIST', function*(action) {
    const range = action.range;
    const date = formatterMonth(action.time);
    const options = {
      url: `/api/b/wallet/settle/records?start=${range.location}&size=${range.length}&startTime=${date.startTime}&endTime=${date.endTime}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadWalletFlowListCompletion(range, result.data, result.error));
  });
}

export function* watchLoadMoneyExport() {
  yield takeEvery('LOAD_MONEY_EXPORT_INFO', function*() {
    const options = {
      url: '/api/b/wallet/take/check',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadMoneyExportInfoCompletion(result.data, result.error));
  });
}

export function* watchExportMoney() {
  yield takeEvery('EXPORT_MONEY', function*({ bankCardId, money, payPass }) {
    const options = {
      url: '/api/b/wallet/take/apply',
      method: 'POST',
      data: { walletCardId: bankCardId, money, password: payPass },
    };
    const result = yield call(app.httpFetch, options);
    yield put(exportMoneyCompletion(result.data, result.error));
  });
}

export default function* walletSaga() {
  yield all([
    fork(watchLoadWalletInfo),
    fork(watchLoadWalletFlowList),
    fork(watchLoadMoneyExport),
    fork(watchExportMoney),
  ]);
}
